export const save = (booking) => async (dispatch, getState) => {
  dispatch({
    type: "SET_SAVED_BOOKING_FOR_PAYMENT",
    booking,
  });
};
